import React, { useState } from 'react';
import { useActionPlanContext } from '../../hooks/ActionPlanContext'; // Verileri hook'tan almak için
import FaqItem from './FaqItem';
import SearchFilterBar from './SearchFilterBar';
import { useRouter } from 'next/router';

const ActionPlanSection = () => {
    const { searchAndFilter } = useActionPlanContext(); // Verileri context'ten çekiyoruz

    const [searchTerm, setSearchTerm] = useState(''); // Arama terimi
    const [selectedPolicyAreas, setSelectedPolicyAreas] = useState<string[]>([]); // Dropdown'dan seçilen alan

    const filteredPolicyAreas = searchAndFilter(searchTerm, selectedPolicyAreas);
    const { locale } = useRouter();
    return (
        <div className="action-plans-section">
            <div className="policy-area-section">

                <SearchFilterBar
                    searchTerm={searchTerm}
                    setSearchTerm={setSearchTerm}
                    selectedPolicyAreas={selectedPolicyAreas}
                    setSelectedPolicyAreas={setSelectedPolicyAreas}
                />

                <div className="filtering-container">
                    {/* Filtrelenen verilerin gösterimi */}
                    <div className="w-dyn-list">
                        <div role="list" className="w-dyn-items">
                            {!filteredPolicyAreas || filteredPolicyAreas.length === 0 &&
                                <div className="w-dyn-empty">
                                    <div>
                                        {locale?.includes('tr') ? 'Sonuç bulunamadı.' : 'No items found.' }
                                        </div>
                                </div>}
                            {filteredPolicyAreas?.map((item) => {

                                return (
                                    <div role="listitem" key={item.policyArea.area_no} className="w-dyn-item">
                                        <div id={`0${item.policyArea.area_no}`} className="w-layout-grid policy-column-holder">
                                            <div className="policy-column-1">
                                                <div className="policy-area-card light">
                                                    <img src={item.policyArea?.imgSrc} alt={item.policyArea?.policy_area} className="policy-area-visual" />
                                                    <div className="number-display turqoise left _120px">0{item.policyArea?.area_no}</div>
                                                    <div className="limited-heading-set">
                                                        <div className="tagline-heading">
                                                             {locale?.includes('tr') ? 'POLİTİKA ALANI' : 'POLICY AREA' }
                                                            </div>
                                                        <h2 className="policy-area-card-title">{item.policyArea?.policy_area}</h2>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="policy-column-2">
                                                <div className='action-plans jetboost-list-wrapper-xr5q w-dyn-list'>
                                                    <div id={`0${item.policyArea.area_no}`} role="list" className="collection-list w-dyn-items">
                                                        {item.policies.map((subItem, index) => {
                                                            return <div role="listitem" key={index} className="w-dyn-item">
                                                                <div className="generic-policy-group-card">
                                                                    <div className="policy-grid">
                                                                        <div className="limited-heading-set">
                                                                            <div className="w-embed">
                                                                                <input type="hidden" className="jetboost-list-item" value="1-1" /></div>
                                                                            <div className="tagline-heading">{subItem.policy.policy_no}</div>
                                                                            <h3 className="h5-heading">{subItem.policy.policy}</h3>
                                                                        </div>
                                                                    </div>
                                                                    {subItem.actions.map((action) => {
                                                                        return <FaqItem action={action} />
                                                                    })}
                                                                </div>
                                                            </div>
                                                        })}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default ActionPlanSection;
